var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "like",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.657,
    height: 68.91,
    viewBox: "0 0 73.657 68.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M32.881,122.918a7.362,7.362,0,0,0,5.485,12.276h14.3a47.607,47.607,0,0,0-2.02,12.441v2.454a9.833,9.833,0,0,0,9.821,9.821h2.455a2.455,2.455,0,0,0,2.382-1.859l1.337-5.351c1.874-7.493,7.824-15.761,13.982-17.264A7.376,7.376,0,0,0,87.47,140.1H102.2a2.456,2.456,0,0,0,2.455-2.455V93.455A2.456,2.456,0,0,0,102.2,91H87.47a7.373,7.373,0,0,0-6.649,4.2l-8.436-2.812A26.947,26.947,0,0,0,63.844,91H43.276a7.368,7.368,0,0,0-6.848,10.08A7.362,7.362,0,0,0,32.881,113.1a7.351,7.351,0,0,0,0,9.821ZM85.015,98.366A2.458,2.458,0,0,1,87.47,95.91H99.746v39.284H87.47a2.458,2.458,0,0,1-2.455-2.455Zm-41.739,22.1h-4.91a2.455,2.455,0,1,1,0-4.91h4.91a2.455,2.455,0,0,0,0-4.91h-4.91a2.455,2.455,0,0,1,0-4.91h4.91a2.455,2.455,0,1,0,0-4.91,2.455,2.455,0,1,1,0-4.91H63.844a22.049,22.049,0,0,1,6.989,1.134l9.271,3.09v30.381c-3.851.732-7.621,3.171-11.024,7.163a35.825,35.825,0,0,0-7.207,13.829L61,155h-.539a4.916,4.916,0,0,1-4.91-4.91v-2.454c0-3.3,1.031-9.62,2.35-12.441h5.015a2.455,2.455,0,0,0,0-4.91H38.366a2.455,2.455,0,1,1,0-4.91h4.91a2.455,2.455,0,0,0,0-4.91Z",
    transform: "translate(-31 -91)",
    fill: "#ffc88d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(58.404 9.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3,
    cy: 2.5,
    rx: 3,
    ry: 2.5,
    transform: "translate(0.306 0.24)",
    fill: "#ffc88d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.1880698374fb955562682ab100e66f76.svg";
export { ForwardRef as ReactComponent };